// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3uVq_","options":"AnswerScale_options__2xZGC","selected":"AnswerScale_selected__3P1Cl"};